
import AddIcon from '@material-ui/icons/Add';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import { lotMechanicalConfigStyles } from './components/LotMechanicalConfig/style';
import Authorize from 'components/Authorize';
import { Button, Grid, Tooltip } from '@material-ui/core';
import Rule from './components/LotMechanicalConfig/Rule';
import { v4 as uuidv4 } from 'uuid';

const AddRule = ({
    clientId,
    lotId,
    clientLots,
    mechanicalsRulesToEdit,
    setMechanicalsRulesToEdit,
    selectLot,
    presetActivityId,
    presetActivityData,
    clientsWithConfigs,
    allowClientSelection = false,
    onUnsavedChanges = null,
    hideVendor = false,
    buttonStyle = null,
    isBundle = false
}) => {
    const classes = lotMechanicalConfigStyles();

    const onAdd = () => {
        setMechanicalsRulesToEdit([
            {
                tempId: uuidv4(),
                clientId: allowClientSelection ? null : clientId,
                lotId: lotId,
                isNew: true,
                appliesTo: "specific-lots",
                activityId: presetActivityId || (presetActivityData ? 'new' : null)
            },
            ...mechanicalsRulesToEdit
        ])
    }

    const onCancel = () => {
        setMechanicalsRulesToEdit([...mechanicalsRulesToEdit?.filter(l => !l?.isNew)])
    }

    const hasNewRule = mechanicalsRulesToEdit?.find(a => a.isNew);
    const hasNoParamTypes = presetActivityData && (!presetActivityData.paramTypes || presetActivityData.paramTypes.length === 0);
    const isDisabled = (allowClientSelection ? hasNewRule : (!clientId || hasNewRule)) || hasNoParamTypes;

    const getTooltipMessage = () => {
        if (hasNoParamTypes) {
            return `Please configure Mechanical SLA Logic in the ${isBundle ? 'Bundle' : 'Activity'} Details step before adding rules`;
        }
        if (hasNewRule) {
            return 'Please save or cancel the current rule before adding a new one';
        }
        return '';
    };

    return (
        <>
            <Authorize profile={permissionProfiles.MECHANICALS_CONFIG.SAVE_CONFIG}>
                <div className={buttonStyle ?? classes.addButton}>
                    <Tooltip title={getTooltipMessage()} arrow disableHoverListener={!isDisabled}>
                        <span>
                            <Button
                                id="basic-button"
                                color="primary"
                                variant="outlined"
                                onClick={() => onAdd()}
                                startIcon={<AddIcon />}
                                disabled={isDisabled}
                            >
                                {'Add Rule'}
                            </Button>
                        </span>
                    </Tooltip>
                </div>
            </Authorize>
            <Grid item>
                {selectLot &&
                    mechanicalsRulesToEdit?.map((rule, index) => <Rule
                        key={rule.id || rule.tempId || index} 
                        ruleIndex={index} 
                        rule={rule} 
                        onCancel={onCancel} 
                        clientLots={clientLots} 
                        selectLot={selectLot} 
                        presetActivityData={presetActivityData} 
                        mechanicalsRulesToEdit={mechanicalsRulesToEdit} 
                        setMechanicalsRulesToEdit={setMechanicalsRulesToEdit} 
                        clientsWithConfigs={clientsWithConfigs} 
                        allowClientSelection={allowClientSelection} 
                        onUnsavedChanges={onUnsavedChanges ? (hasUnsaved) => onUnsavedChanges(rule.id || rule.tempId || index, hasUnsaved) : undefined} 
                        hideVendor={hideVendor}
                    />)
                }
            </Grid>
        </>
    )
}

export default AddRule;